/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { TransportMiddlewareProps, AuthInternalError, isErrorThatNeedToBeShown } from '../../../../core';

import type { TransportMiddlewareContext, TransportMiddlewareRequest, TransportMiddlewareResponse, NextFunction } from '../../../../core';

export const handleHttpErrorMiddleware = <T, R, E>(
    next: NextFunction<TransportMiddlewareResponse<R, E> | Error>,
    ctx: TransportMiddlewareContext,
    req: TransportMiddlewareRequest<T>,
    res: TransportMiddlewareResponse<R, E>
) => {
    const { commands } = ctx;
    const { url, options, requestInit } = req;
    const { notShowDefaultError, backendErrorTitle, type } = options;
    const { response } = res;
    const errorResponse = res[TransportMiddlewareProps.ErrorResponse];

    if (errorResponse instanceof AuthInternalError) {
        commands.showAuthError();
        next(res);
        return;
    }

    response.json()
        .then((errorResponse: E) => {
            if (requestInit.signal?.aborted) {
                res[TransportMiddlewareProps.ErrorResponse] = errorResponse as E;
                next(res);
                return;
            }

            commands.log(url, errorResponse);

            if (!notShowDefaultError) {
                commands?.showBackendError(errorResponse as any as E, {
                    url,
                    title: backendErrorTitle ?? null,
                    type,
                });
            }

            res[TransportMiddlewareProps.ErrorResponse] = errorResponse as E;
            next(res);
        })
        .catch((err: Error) => {
            commands.log(url, response as Response);

            if (!notShowDefaultError) {
                commands?.showBackendError(null, {
                    url,
                    title: backendErrorTitle ?? null,
                    type,
                });
            }

            isErrorThatNeedToBeShown(err) && console.error(err);
            res[TransportMiddlewareProps.ErrorResponse] = err;
            next(res);
        });
};
